'use client'
import { storyblokEditable } from '@storyblok/react'
import { useProductMetadata } from '@/components/LayoutWithMenu/productMetadataHooks'
import { SelectInsuranceGrid } from '@/components/SelectInsuranceGrid/SelectInsuranceGrid'
import type { SbBaseBlockProps } from '@/services/storyblok/storyblok'
import { grid } from './SelectInsuranceGridBlock.css'

type Props = SbBaseBlockProps<{
  title?: string
  openPriceCalculator?: boolean
}>

export function SelectInsuranceGridBlock({ blok, nested }: Props) {
  const products = useProductMetadata()
  const openPriceCalculator = blok.openPriceCalculator ?? true

  return (
    <SelectInsuranceGrid
      className={grid}
      data-nested={nested}
      heading={blok.title}
      products={products ?? []}
      openPriceCalculator={openPriceCalculator}
      {...storyblokEditable(blok)}
    />
  )
}
